import cn from "./cn";
import ko from "./ko";
import en from "./en";
export default {
  cn,
  ko,
  en
}


// WEBPACK FOOTER //
// ./src/components/common/langs/index.js